@if (inputForm) {
  <ng-container *transloco="let t">
    <form [formGroup]="inputForm">
      <div>
        <!--    New organizer card-->
        <app-admin-card-with-title [cardTitle]="getFormTitle()"
                                   [isContentVisible]="!isNewOrganizerCollapsed"
                                   [removeTopMargin]="true">
          <div>
            <div class="row">
              <div class="col-12 col-lg-4">
                <app-input formControlName="name" label="organiser.details.name"/>
              </div>
              <div class="col-12 col-lg-4">
                <app-input formControlName="fullName" label="organiser.details.full.name"/>
              </div>
              <div class="col-12 col-lg-4">
                <app-input formControlName="website" label="organiser.details.web"/>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-12 col-lg-4">
                <app-input formControlName="email" label="organiser.details.email"/>
              </div>
              <div class="col-12 col-lg-4">
                <app-tel-input formControlName="phone" [label]="t('organiser.details.phone')"
                               [numberPlaceholder]="t('organiser.details.phone')"/>
              </div>
              <div class="col-12 col-lg-4">
                <app-input formControlName="address" label="organiser.details.address"/>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-12 col-lg-4">
                <app-input formControlName="place" label="organiser.details.place"/>
              </div>
              <div class="col-12 col-lg-4">
                <app-input formControlName="zip" label="app.common.zip"/>
              </div>
              <div class="col-12 col-lg-4">
                <app-select formControlName="country" [items]="countries" [valueKey]="'id'" [labelKey]="'name'"
                            [hasDefault]="true" label="app.common.country"/>
              </div>
            </div>
          </div>
        </app-admin-card-with-title>
        <!--    Editor card-->

        <app-admin-card-with-title [cardTitle]="t('app.common.description')"
                                   [isContentVisible]="!isEditorCollapsed" [showToggleButton]="true">
          <app-rich-text-editor-wrapper (contentChange)="onDescriptionChangeEvent($event)"
                                        [content]="this.currentOrganiser?.info"/>
        </app-admin-card-with-title>

        <!--                        Upload file card-->
        <app-admin-card-with-title [cardTitle]="t('app.common.upload.file')"
                                   [isContentVisible]="!isDragAndDropCollapsed" [showToggleButton]="true">
          <app-drag-and-drop [selectedFile]="inputForm.value.image" (fileChange)="imageChange($event)"
                             [useWithCropper]="true"></app-drag-and-drop>
        </app-admin-card-with-title>

        <!--                        Organizer links card-->
        <app-admin-card-with-title [cardTitle]="t('organiser.details.organiser.links')"
                                   [isContentVisible]="!isOrganizerLinksCollapsed" [showToggleButton]="true">
          <div class="form-group" formGroupName="organiserLinks">
            <div class="row">
              <div class="col-12 col-lg-4">
                <div class="form-floating pb-38-34">
                  <app-input type="text" formControlName="facebook" id="facebook"
                             label="{{t('organiser.details.facebook')}}"
                             placeholder='{{t("organiser.details.facebook")}}' [labelIsVisible]="false"/>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-floating pb-38-34">
                  <app-input type="text" formControlName="twitter" id="twitter"
                             label="{{t('organiser.details.twitter')}}"
                             placeholder="{{t('organiser.details.twitter')}}" [labelIsVisible]="false"/>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-floating pb-38-34">
                  <app-input type="text" formControlName="googleplus" id="googleplus"
                             label="{{t('organiser.details.google')}}"
                             placeholder="{{t('organiser.details.google')}}" [labelIsVisible]="false"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-4">
                <div class="form-floating pb-38-34">
                  <app-input type="text" formControlName="flickr" id="flickr" label="{{t('organiser.details.flickr')}}"
                             placeholder="{{t('organiser.details.flickr')}}" [labelIsVisible]="false"/>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-floating pb-38-34">
                  <app-input type="text" formControlName="picasa" id="picasa" label="{{t('organiser.details.picasa')}}"
                             placeholder="{{t('organiser.details.picasa')}}" [labelIsVisible]="false"/>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-floating pb-38-34">
                  <app-input type="text" formControlName="youtube" id="youtube"
                             label="{{t('organiser.details.youtube')}}"
                             placeholder="{{t('organiser.details.youtube')}}" [labelIsVisible]="false"/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-4">
                <div class="form-floating mb-3">
                  <app-input type="text" formControlName="vimeo" id="vimeo" label="{{t('organiser.details.vimeo')}}"
                             placeholder="{{t('organiser.details.vimeo')}}" [labelIsVisible]="false"/>
                </div>
              </div>
            </div>
          </div>
        </app-admin-card-with-title>
        <app-action-buttons-row [backVisible]="authenticationService.isAdmin()" (onSave)="onSave()"/>
      </div>
    </form>
  </ng-container>
}
